/** How each browser words a fetch that failed on the network: Chrome, Firefox, Safari. */
const NETWORK_ERROR_MESSAGES = [
  'Failed to fetch',
  'NetworkError when attempting to fetch resource.',
  'Load failed',
];

/** A fetch rejected because the network failed, not because of a response. */
export function isNetworkError(error: unknown): boolean {
  return (
    error instanceof TypeError && NETWORK_ERROR_MESSAGES.includes(error.message)
  );
}
